/* RESPONSIBLE TEAM: team-workflows */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable no-restricted-imports */
import {
  TICKET_CREATED_TARGET,
  TRIGGERABLE_BOT_TYPE,
  TICKET_CREATED_TRIGGER,
  TICKET_ONLY,
  WORKFLOWS_SETUP_TRIGGER_TICKET_ONLY,
  WORKFLOWS_SETUP_TRIGGER_INTERNAL_PROCESS,
} from 'embercom/lib/operator/custom-bots/constants';
import {
  matchBehaviors,
  objectTypes,
} from 'embercom/models/data/matching-system/matching-constants';

import CustomBotConfig from '../custom-bot';
import type { TargetContext } from '../custom-bot';
import { computeSelectedTargetContexts, TICKET_TRIGGER_PREDICATES } from '../target-context-config';
import TicketTriggerEditorConfig from 'embercom/objects/visual-builder/configuration/editor/ticket-trigger';
import type { BotConfigTarget } from '../configuration';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

export default class TicketCreatedCustomBotConfig extends CustomBotConfig {
  get target(): BotConfigTarget {
    return TICKET_CREATED_TARGET;
  }

  get botType() {
    return TRIGGERABLE_BOT_TYPE;
  }

  get objectType() {
    return objectTypes.triggerableCustomBot;
  }

  get trigger() {
    return TICKET_CREATED_TRIGGER;
  }

  get matchBehavior() {
    return matchBehaviors.transient;
  }

  get titleTranslationKey() {
    return 'operator.custom-bot.trigger.ticket-created.title';
  }

  get descriptionTranslationKey() {
    return 'operator.custom-bot.trigger.ticket-created.description';
  }

  get triggerPredicatesDescriptionTranslationKey() {
    return 'operator.custom-bot.trigger.ticket-created.trigger-predicates-description';
  }

  get icon(): InterfaceIconName {
    return 'ticket';
  }

  get editorConfig() {
    return new TicketTriggerEditorConfig({
      targetChannels: this.customBot?.targetChannels,
      areStepPaywallsActive: this.areStepPaywallsActive,
      targetContexts: this.selectedTargetContexts,
      workflow: this.workflow,
    });
  }

  get EditorConfigClass() {
    return TicketTriggerEditorConfig;
  }

  get triggerPredicates() {
    return TICKET_TRIGGER_PREDICATES;
  }

  get requiredBillingFeature() {
    return 'workflows_core_billing_feature';
  }

  get triggerContextType() {
    return TICKET_ONLY;
  }

  get selectedTargetContexts(): TargetContext[] | null {
    if (this.customBot?.triggerPredicateGroup) {
      return computeSelectedTargetContexts(this.customBot.triggerPredicateGroup);
    } else {
      return null;
    }
  }

  get workflowsSetupTriggerType(): string[] {
    return [WORKFLOWS_SETUP_TRIGGER_TICKET_ONLY, WORKFLOWS_SETUP_TRIGGER_INTERNAL_PROCESS];
  }
}
